export var ConfigurationStatus;
(function (ConfigurationStatus) {
    ConfigurationStatus["UNKNOWN"] = "UNKNOWN";
    ConfigurationStatus["NOT_STARTED"] = "NOT_STARTED";
    ConfigurationStatus["PENDING"] = "PENDING";
    ConfigurationStatus["READY"] = "READY";
    ConfigurationStatus["ERROR"] = "ERROR";
})(ConfigurationStatus || (ConfigurationStatus = {}));
export var CatalogSyncErrorCode;
(function (CatalogSyncErrorCode) {
    CatalogSyncErrorCode["NONE"] = "NONE";
    CatalogSyncErrorCode["OTHER"] = "OTHER";
    CatalogSyncErrorCode["SYSTEM_ERROR"] = "SYSTEM_ERROR";
    CatalogSyncErrorCode["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    CatalogSyncErrorCode["ACCOUNT_NOT_AUTHORIZED"] = "ACCOUNT_NOT_AUTHORIZED";
    CatalogSyncErrorCode["LOCATION_NOT_FOUND"] = "LOCATION_NOT_FOUND";
    CatalogSyncErrorCode["ACCOUNT_NOT_CONNECTED"] = "ACCOUNT_NOT_CONNECTED";
    CatalogSyncErrorCode["ACCOUNT_CONFIGURATION"] = "ACCOUNT_CONFIGURATION";
    CatalogSyncErrorCode["OVERLOADED_MENU"] = "OVERLOADED_MENU";
})(CatalogSyncErrorCode || (CatalogSyncErrorCode = {}));
export var Status;
(function (Status) {
    /** UNKNOWN STATUS. */
    Status["UNKNOWN"] = "UNKNOWN";
    /** Sync didn't started yet. */
    Status["PENDING"] = "PENDING";
    /** Sync is in progress. */
    Status["IN_PROGRESS"] = "IN_PROGRESS";
    /** Sync completed successfully. */
    Status["SYNCED"] = "SYNCED";
    /** Sync completed with failure. */
    Status["FAILED"] = "FAILED";
})(Status || (Status = {}));
export var SyncFailedCode;
(function (SyncFailedCode) {
    SyncFailedCode["NONE"] = "NONE";
    SyncFailedCode["OTHER"] = "OTHER";
    SyncFailedCode["SYSTEM_ERROR"] = "SYSTEM_ERROR";
    SyncFailedCode["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    SyncFailedCode["ACCOUNT_NOT_AUTHORIZED"] = "ACCOUNT_NOT_AUTHORIZED";
    SyncFailedCode["LOCATION_NOT_FOUND"] = "LOCATION_NOT_FOUND";
    SyncFailedCode["ACCOUNT_NOT_CONNECTED"] = "ACCOUNT_NOT_CONNECTED";
    SyncFailedCode["ACCOUNT_CONFIGURATION"] = "ACCOUNT_CONFIGURATION";
    SyncFailedCode["OVERLOADED_MENU"] = "OVERLOADED_MENU";
})(SyncFailedCode || (SyncFailedCode = {}));
export var CatalogSyncStatusErrorCode;
(function (CatalogSyncStatusErrorCode) {
    CatalogSyncStatusErrorCode["NONE"] = "NONE";
    CatalogSyncStatusErrorCode["OTHER"] = "OTHER";
    CatalogSyncStatusErrorCode["SYSTEM_ERROR"] = "SYSTEM_ERROR";
    CatalogSyncStatusErrorCode["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    CatalogSyncStatusErrorCode["ACCOUNT_NOT_AUTHORIZED"] = "ACCOUNT_NOT_AUTHORIZED";
    CatalogSyncStatusErrorCode["LOCATION_NOT_FOUND"] = "LOCATION_NOT_FOUND";
    CatalogSyncStatusErrorCode["ACCOUNT_NOT_CONNECTED"] = "ACCOUNT_NOT_CONNECTED";
    CatalogSyncStatusErrorCode["ACCOUNT_CONFIGURATION"] = "ACCOUNT_CONFIGURATION";
    CatalogSyncStatusErrorCode["OVERLOADED_MENU"] = "OVERLOADED_MENU";
})(CatalogSyncStatusErrorCode || (CatalogSyncStatusErrorCode = {}));
export var DisplayType;
(function (DisplayType) {
    /** DisplayType, due to an error */
    DisplayType["UNSPECIFIED_DISPLAY_TYPE"] = "UNSPECIFIED_DISPLAY_TYPE";
    /** Single choice selection */
    DisplayType["SELECTION"] = "SELECTION";
    /** Multiple choices selection */
    DisplayType["EXTRAS"] = "EXTRAS";
    /** Allow choices removal */
    DisplayType["DESELECTION"] = "DESELECTION";
})(DisplayType || (DisplayType = {}));
export var DiscountType;
(function (DiscountType) {
    DiscountType["UNSPECIFIED_TYPE"] = "UNSPECIFIED_TYPE";
    DiscountType["OFF_ITEM"] = "OFF_ITEM";
    DiscountType["OFF_ORDER"] = "OFF_ORDER";
    DiscountType["OFF_ORDER_MANAGER_DISCOUNT"] = "OFF_ORDER_MANAGER_DISCOUNT";
})(DiscountType || (DiscountType = {}));
export var Type;
(function (Type) {
    /** Missing type due to an error */
    Type["UNSPECIFIED_FULFILLMENT_TYPE"] = "UNSPECIFIED_FULFILLMENT_TYPE";
    /** Pickup */
    Type["PICKUP"] = "PICKUP";
    /** Delivery */
    Type["DELIVERY"] = "DELIVERY";
    /** Dine-in */
    Type["DINE_IN"] = "DINE_IN";
})(Type || (Type = {}));
export var OnArrival;
(function (OnArrival) {
    /** Missing type due to an error */
    OnArrival["UNSPECIFIED_ON_ARRIVAL_TYPE"] = "UNSPECIFIED_ON_ARRIVAL_TYPE";
    /** Buzz the door */
    OnArrival["BUZZ_DOOR"] = "BUZZ_DOOR";
    /** Phone me */
    OnArrival["CALL_ME"] = "CALL_ME";
})(OnArrival || (OnArrival = {}));
export var PaymentType;
(function (PaymentType) {
    /** PaymentType, due to an error */
    PaymentType["UNSPECIFIED_PAYMENT_TYPE"] = "UNSPECIFIED_PAYMENT_TYPE";
    /** Cash */
    PaymentType["CASH"] = "CASH";
    /** credit */
    PaymentType["CREDIT"] = "CREDIT";
    /** Delivery club */
    PaymentType["DELIVERY_CLUB"] = "DELIVERY_CLUB";
    /** Delivery com */
    PaymentType["DELIVERY_COM"] = "DELIVERY_COM";
    /** Bitpay */
    PaymentType["BITPAY"] = "BITPAY";
    /** Cellarix */
    PaymentType["CELLARIX"] = "CELLARIX";
    /** Bits of gold */
    PaymentType["BITSOFGOLD"] = "BITSOFGOLD";
    /** Multi pass */
    PaymentType["MULTIPASS"] = "MULTIPASS";
    /** Tenbis */
    PaymentType["TENBIS"] = "TENBIS";
    /** Paypal */
    PaymentType["PAYPAL"] = "PAYPAL";
    /** Mysodexo */
    PaymentType["MYSODEXO"] = "MYSODEXO";
    /** Wix Payments */
    PaymentType["WIX_PAYMENTS"] = "WIX_PAYMENTS";
})(PaymentType || (PaymentType = {}));
export var Code;
(function (Code) {
    Code["NONE"] = "NONE";
    Code["OTHER"] = "OTHER";
    Code["SYSTEM_ERROR"] = "SYSTEM_ERROR";
    Code["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    Code["ACCOUNT_NOT_AUTHORIZED"] = "ACCOUNT_NOT_AUTHORIZED";
    Code["LOCATION_NOT_FOUND"] = "LOCATION_NOT_FOUND";
    Code["ACCOUNT_NOT_CONNECTED"] = "ACCOUNT_NOT_CONNECTED";
    Code["ACCOUNT_CONFIGURATION"] = "ACCOUNT_CONFIGURATION";
    Code["PROMO_NOT_RECOGNIZED"] = "PROMO_NOT_RECOGNIZED";
    Code["PROMO_USER_INELIGIBLE"] = "PROMO_USER_INELIGIBLE";
    Code["PROMO_ALREADY_USED"] = "PROMO_ALREADY_USED";
    Code["PROMO_EXPIRED"] = "PROMO_EXPIRED";
    Code["DISCOUNT"] = "DISCOUNT";
    Code["LOYALTY"] = "LOYALTY";
    Code["OUT_OF_SERVICE_AREA"] = "OUT_OF_SERVICE_AREA";
    Code["AVAILABILITY_CHANGED"] = "AVAILABILITY_CHANGED";
    Code["PRICE_CHANGED"] = "PRICE_CHANGED";
    Code["NO_CAPACITY"] = "NO_CAPACITY";
    Code["CLOSED"] = "CLOSED";
    Code["REQUIREMENTS_NOT_MET"] = "REQUIREMENTS_NOT_MET";
    Code["ORDER_TOTAL"] = "ORDER_TOTAL";
    Code["ORDER_ITEM"] = "ORDER_ITEM";
    Code["ORDER_REJECTED"] = "ORDER_REJECTED";
    Code["PAYMENT_FAILED"] = "PAYMENT_FAILED";
    Code["CUSTOMER_PHONE_MISSING"] = "CUSTOMER_PHONE_MISSING";
    Code["CUSTOMER_EMAIL_MISSING"] = "CUSTOMER_EMAIL_MISSING";
    Code["CUSTOMER_BLOCKED"] = "CUSTOMER_BLOCKED";
})(Code || (Code = {}));
export var Default;
(function (Default) {
    Default["WIX"] = "WIX";
    Default["POS"] = "POS";
})(Default || (Default = {}));
export var IdentityType;
(function (IdentityType) {
    IdentityType["UNKNOWN"] = "UNKNOWN";
    IdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    IdentityType["MEMBER"] = "MEMBER";
    IdentityType["WIX_USER"] = "WIX_USER";
    IdentityType["APP"] = "APP";
})(IdentityType || (IdentityType = {}));
//# sourceMappingURL=types.impl.js.map